import { HttpContextToken } from '@angular/common/http';

/**
 * Marks a request whose failure is an expected answer handled by the caller, so the global
 * error interceptor does not show it to the user.
 */
export const SILENT_ERROR = new HttpContextToken<boolean>(() => false);
